import {
  Box,
  Checkbox,
  useTheme,
  FormControlLabel,
  FormControl,
  Typography,
} from "@mui/material";

import FormHelperText from "../FormHelperText";
import { tokens } from "../../../theme/theme";

const TypeCheckbox = ({
  field,
  dataCollection,
  errors,
  updateValidationOnChange,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  function handleChange(value) {
    updateValidationOnChange([field.key], value.target.checked);
  }

  const showUncheckedWarning =
    field.warningWhenUnchecked && !dataCollection[field.key];

  return (
    <Box className="flex flex-col justify-center">
      <Box
        className="flex justify-start items-center"
        sx={{
          minHeight: "53px",
        }}
      >
        <FormControlLabel
          label={field.label}
          control={
            <Checkbox
              onChange={handleChange}
              color="secondary"
              checked={dataCollection[field.key]}
            />
          }
        />
        <FormHelperText
          error={Boolean(errors[field.key])}
          helperText={errors[field.key]}
        />
      </Box>
      {showUncheckedWarning && (
        <Typography
          color="error"
          sx={{ fontSize: "0.8rem", ml: "14px", mt: "-6px", mb: "4px" }}
        >
          {field.warningWhenUnchecked}
        </Typography>
      )}
    </Box>
  );
};

export default TypeCheckbox;
